import axios from 'axios';
import store from './store';

//axios.defaults.baseURL="/cool";
axios.defaults.timeout = 10000;

axios.interceptors.request.use(
    config => {
        if(store.state.type==0){
            //axios.defaults.baseURL="/cool";
            config.baseURL="/cool";
        }else{
            //axios.defaults.baseURL="/destiny";
            config.baseURL="/destiny";
        };
        config.url = "/api"+config.url;
       config.headers={
           "X-Auth":store.state.token
        };
        return config;
    },
    error => {
        return Promise.reject(error);
    });

axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data.data);
        } else {
            return Promise.reject(response.data);
        }
    },
    error => {
        /*if(error.response.data.code===503){
            store.commit('logout');
            window.location='/';
        }*/
        return Promise.reject(error.response.data);
    }
);



// WEBPACK FOOTER //
// ./src/service/http.js